import { GlobalStyles as GlobalStylesComponent } from '@mui/material';

function GlobalStyles() {
  return (
    <GlobalStylesComponent
      styles={{
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
      }}
    />
  );
}

export default GlobalStyles;
